import {Form, Input, Col, Row, Button, Flex} from "antd";

const ProfileForm = () => {










  return (
    <>
      {/* <Row className="d-flex align-items-center align-items-sm-start justify-content-sm-around flex-sm-row flex-column"> */}
      <Flex className="d-flex align-items-center align-items-sm-start justify-content-sm-around flex-sm-row flex-column" wrap="wrap">
        <Col lg={9} sm={11} className="w-100">
          <Form.Item
            name="name"
            label="name"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please fill this field",
            //   },
            // ]}
          >
            <Input placeholder="name" />
          </Form.Item>
        </Col>
        <Col lg={9} sm={11} className="w-100">
          <Form.Item
            name="surname"
            label="surname"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please fill this field",
            //   },
            // ]}
          >
            <Input placeholder="surname" />
          </Form.Item>
        </Col>
        <Col lg={9} sm={11} className="w-100">
          <Form.Item
            name="phoneNumber"
            label="phone number"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please fill this field",
            //   },
            // ]}
          >
            <Input placeholder="phone number" />
          </Form.Item>
        </Col>
        <Col lg={9} sm={11} className="w-100">
          <Form.Item
            name="country"
            label="country"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please fill this field",
            //   },
            // ]}
          >
            <Input placeholder="country" />
          </Form.Item>
        </Col>
        

        <Col className="w-100">
        <Form.Item
        name="description"
        label="Description"
        // rules={[
        //   {
        //     required: true,
        //     message: 'Please input Intro',
        //   },
        // ]}
      >
        <Input.TextArea rows={4} showCount maxLength={100} />
      </Form.Item>
        </Col>
        <Col className="d-flex justify-content-center w-100">
            <Button type="primary" htmlType="submit">Save</Button>
        </Col>
      {/* </Row> */}
      </Flex>
    </>
  );
};

export default ProfileForm;
